module.exports = __webpack_public_path__ + "static/media/reader4.c7516d43.jpg";